import useStore from '../store'
import { root } from './root.js'
import { marketing } from './marketing.js'
import { accounts } from './accounts.js'
import { users } from './users.js'
import { uploads } from './uploads.js'
import { teams } from './teams.js'
import { trials } from './trials.js'
import { participants } from './participants.js'
import { participantNotes } from './participantNotes.js'
import { participantEvents } from './participantEvents.js'
import { dataTypes } from './dataTypes.js'
import { dataTypeTags } from './dataTypeTags.js'
import { stages } from './stages.js'
import { stageGroups } from './stageGroups.js'
import { groups } from './groups.js'
import { sites } from './sites.js'
import { siteMonitoring } from './siteMonitoring.js'
import { siteMonitoringIssues } from './siteMonitoringIssues.js'
import { files } from './files.js'
import { nutrition } from './nutrition.js'
import { foodDiaries } from './foodDiaries.js'
import { dashboards } from './dashboards.js'
import { automaticQueries } from './automaticQueries.js'
import { packs } from './packs.js'
import { queries } from './queries.js'
import { tasks } from './tasks.js'
import { taskLanes } from './taskLanes.js'
import { webhooks } from './webhooks.js'
import { oauth } from './oauth.js'
import { roles } from './roles.js'
import { promis } from './promis.js'
import { invitations } from './invitations.js'
import { tillo } from './tillo.js'
import { assistant } from './assistant.js'
import { insights } from './insights.js'
import { participantResources } from './participantResources.js'
import { anchors } from './anchors.js'
import { consentSessions } from './consentSessions.js'

export const api = {

  req (method, path, data, success, fail, withAuth, options) {
    const xhr = new window.XMLHttpRequest()
    xhr.open(method, `${import.meta.env.VITE_API_URL}${path}`)
    xhr.setRequestHeader('Content-Type', 'application/json')
    const token = useStore.getState().token
    if (withAuth && token) {
      xhr.setRequestHeader('Authorization', `Bearer ${token}`)
    }
    if (options && options.extraHeaders) {
      for (const [key, value] of Object.entries(options.extraHeaders)) {
        xhr.setRequestHeader(key, value)
      }
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response
          if (options && options.plain) response = xhr.responseText
          else {
            try { response = JSON.parse(xhr.responseText) } catch (err) { console.log(err) }
          }
          if (success) success(response)
        } else {
          if (xhr.status === 401) {
            if (token) {
              accounts.localLogout(() => useStore.getState().completeLogout())
            }
            return fail && fail({ status: 401, message: 'Authorisation is needed' })
          }
          try {
            const parsedResponse = JSON.parse(xhr.responseText)
            const { message, details } = parsedResponse
            if (xhr.status === 403 && details?.code === 'mfa_enrolment_required') {
              // A session that still has to set up a second factor. Flag it
              // so App.jsx swaps in the enrolment screen, whatever page the
              // user was on; the caller still gets its failure as normal.
              const { user, updateUser } = useStore.getState()
              if (user) updateUser(user._id, { mfaEnrolRequired: true })
            }
            fail && fail({ status: xhr.status, message, details })
          } catch (err) {
            fail && fail({ status: xhr.status, message: 'There was a problem with this request' })
          }
        }
      }
    }
    xhr.send(data && JSON.stringify(data))
  },

  unauthenticatedRequest (method, path, data, success, fail, options) {
    api.req(method, path, data, success, fail, false, options)
  },

  authenticatedRequest (method, path, data, success, fail, options) {
    api.req(method, path, data, success, fail, true, options)
  },

  root,
  marketing,
  accounts,
  users,
  uploads,
  teams,
  trials,
  participants,
  participantNotes,
  participantEvents,
  dataTypes,
  dataTypeTags,
  stages,
  stageGroups,
  groups,
  sites,
  siteMonitoring,
  siteMonitoringIssues,
  files,
  nutrition,
  foodDiaries,
  dashboards,
  automaticQueries,
  packs,
  queries,
  tasks,
  taskLanes,
  webhooks,
  oauth,
  roles,
  promis,
  invitations,
  tillo,
  assistant,
  insights,
  participantResources,
  anchors,
  consentSessions
}

export default api
